import React, { ReactElement } from 'react';
import { Container, IconContainer, Title } from './styled';

export type CardType = 'primary' | 'secondary';

export type CardConfig = {
    icon: ReactElement;
    title: string;
};

export interface DescriptionCardProps {
    type: CardType;
    config: CardConfig;
}

export const SchoolDescriptionCard: React.FC<DescriptionCardProps> = ({
    type,
    config: { icon, title },
}): JSX.Element => (
    <Container type={type}>
        <Title>{title}</Title>
        <IconContainer>{icon}</IconContainer>
    </Container>
);

export default SchoolDescriptionCard;
